import React from "react";

const aneesh_phatak = () => {
  return (
    <div>
      <h1>Aneesh Phatak</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        For the apti test, the company did the shortlisting on their own
        criteria which they didn't specify, but it looked majorly on the basis
        of CGPA (&gt; 8) and Branch.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The interviews were scheduled the very next day of the aptitude test.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />1 Technical (\~45-50 min), 1 HR (25\~30 min)
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        12 Students were shortlisted for interviews
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        Since the interviews were scheduled the very next day, I majorly focused
        on the projects mentioned in my resume and the techstack used for the
        projects(for eg for my webdev project I revised concepts of flask,
        reactjs).
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        So for the technical round, the panel mainly asked questions based on
        the projects mentioned in my resume. I would recommend being familiar
        with each and every detail about your projects.Out of 12 students, 4
        were shortlisted for HR interview and 3 were given the internship offer.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        Since my projects were related to webdev and chrome extensions,
        questions were asked about flask, javascript, basic DBMS and sql
        queries, basic DSA (eg implement a queue using 2 stacks and some
        questions about linkedlist, arrays).Since I had deployed my website (a
        typing test website like monkeytyping), the interviewer also checked it
        out during the interview and asked a bit about render, vercel.
        <br />
        In both technical and HR rounds I was asked puzzles (teded riddle type).
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Striver’s DSA sheet, DBMS by babbar, basic OS gate smashers
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Be in a habit of solving 3-4 GOOD DSA problems everyday for atleast 2
        months.
        <br />
        If that is done I don’t think any last minute preparation is necessary.
        <br />
        Stay calm and don’t panic during the technical interview even if you
        don't have the answer to the problem.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Since I am a member of the cultural club and I was a part of 2 firodiya
        Karandak winning plays, a lot of discussion in HR round was about
        this.Atleast in my case, extracurricular and club activities were a big
        plus point during HR interview.{" "}
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Read and research a bit about the company, what it does and does the
        work align with your interests.There were 3-4 questions in apti about
        this and also in the HR round.Interest in ML, maths was a plus{" "}
        <a href="http://point.In">point.In</a> my opinion what mattered was that
        even if the level of your project is not very high or difficult, you
        should know absolutely each and every minute detail about your project.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Internship season is the most unpredictable period. You will see the
        most unexpected things happen , sometimes you will get rejected even
        when you are sure of an offer , sometimes you will feel you deserved the
        offer more than a person who was selected. What matters is continuously
        learning from the mistakes in previous aptitude tests and interviews and
        building up on them.{" "}
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:phatakam23.comp@coeptech.ac.in">phatakam23.comp@coeptech.ac.in</a>
      </p>
    </div>
  );
};

export default aneesh_phatak;
